import { cn } from '@talentmesh/ui/lib/utils';
import dompurify from 'dompurify';

interface HtmlViewerProps {
    html: string;
    className?: string;
}

const HtmlViewer = ({ html, className }: HtmlViewerProps) => {
    return (
        <div
            className={cn('text-base leading-relaxed [&_img]:max-w-full', className)}
            dangerouslySetInnerHTML={{ __html: dompurify.sanitize(html) }}
        />
    );
};

export default HtmlViewer;
